"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONNumberingListImporter = void 0;
var list_level_1 = require("../../../numbering-lists/list-level");
var numbering_list_1 = require("../../../numbering-lists/numbering-list");
var json_list_enums_1 = require("../../enums/json-list-enums");
var JSONNumberingListImporter = (function () {
    function JSONNumberingListImporter() {
    }
    JSONNumberingListImporter.importAbstractNumberingLists = function (documentModel, content) {
        for (var _i = 0, content_1 = content; _i < content_1.length; _i++) {
            var jsonNumbList = content_1[_i];
            documentModel.abstractNumberingLists.push(JSONNumberingListImporter.getAbstractNumbertingList(documentModel, jsonNumbList));
        }
    };
    JSONNumberingListImporter.importNumberingLists = function (documentModel, content) {
        for (var _i = 0, content_2 = content; _i < content_2.length; _i++) {
            var jsonNumbList = content_2[_i];
            documentModel.numberingLists.push(JSONNumberingListImporter.getNumberingList(documentModel, jsonNumbList));
        }
    };
    JSONNumberingListImporter.importAbstractNumberingListTemplates = function (documentModel, content) {
        if (!content)
            return;
        for (var _i = 0, content_3 = content; _i < content_3.length; _i++) {
            var jsonNumbList = content_3[_i];
            documentModel.abstractNumberingListTemplates.push(JSONNumberingListImporter.getAbstractNumbertingList(documentModel, jsonNumbList));
        }
    };
    JSONNumberingListImporter.getAbstractNumbertingList = function (documentModel, content) {
        var abstractNumberingList = new numbering_list_1.AbstractNumberingList(documentModel);
        abstractNumberingList.deleted = !!content[json_list_enums_1.JSONAbstractNumberingListProperty.Deleted];
        abstractNumberingList.innerId = content[json_list_enums_1.JSONAbstractNumberingListProperty.Id];
        abstractNumberingList.levels = JSONNumberingListImporter.getAbstractNumberingListLevels(documentModel, content[json_list_enums_1.JSONAbstractNumberingListProperty.Levels]);
        return abstractNumberingList;
    };
    JSONNumberingListImporter.getNumberingList = function (documentModel, content) {
        var numberingList = new numbering_list_1.NumberingList(documentModel, content[json_list_enums_1.JSONNumberingListProperty.AlIndex]);
        numberingList.deleted = false;
        numberingList.innerId = content[json_list_enums_1.JSONNumberingListProperty.Id];
        numberingList.levels = JSONNumberingListImporter.getNumberingListLevels(documentModel, content[json_list_enums_1.JSONNumberingListProperty.Levels], numberingList);
        return numberingList;
    };
    JSONNumberingListImporter.getAbstractNumberingListLevels = function (documentModel, content) {
        var result = [];
        for (var i = 0, obj; obj = content[i]; i++) {
            var maskedCharacterProperties = documentModel.cache.maskedCharacterPropertiesCache.getItemByJsonKey(obj[json_list_enums_1.JSONNumberingListLevelProperty.CharacterPropertiesIndex]);
            var maskedParagraphProperties = documentModel.cache.maskedParagraphPropertiesCache.getItemByJsonKey(obj[json_list_enums_1.JSONNumberingListLevelProperty.ParagraphPropertiesIndex]);
            var listLevelProperties = documentModel.cache.listLevelPropertiesCache.getItemByJsonKey(obj[json_list_enums_1.JSONNumberingListLevelProperty.ListLevelPropertiesIndex]);
            result.push(new list_level_1.ListLevel(documentModel, maskedCharacterProperties, maskedParagraphProperties, listLevelProperties));
        }
        return result;
    };
    JSONNumberingListImporter.getNumberingListLevels = function (documentModel, content, numberingList) {
        var result = [];
        for (var _i = 0, content_4 = content; _i < content_4.length; _i++) {
            var obj = content_4[_i];
            var listLevel = void 0;
            if (obj[json_list_enums_1.JSONNumberingOverrideListLevelProperty.Level] === undefined) {
                var maskedCharacterProperties = documentModel.cache.maskedCharacterPropertiesCache.getItemByJsonKey(obj[json_list_enums_1.JSONNumberingListLevelProperty.CharacterPropertiesIndex]);
                var maskedParagraphProperties = documentModel.cache.maskedParagraphPropertiesCache.getItemByJsonKey(obj[json_list_enums_1.JSONNumberingListLevelProperty.ParagraphPropertiesIndex]);
                var listLevelProperties = documentModel.cache.listLevelPropertiesCache.getItemByJsonKey(obj[json_list_enums_1.JSONNumberingListLevelProperty.ListLevelPropertiesIndex]);
                listLevel = new list_level_1.OverrideListLevel(documentModel, maskedCharacterProperties, maskedParagraphProperties, listLevelProperties);
            }
            else {
                listLevel = new list_level_1.NumberingListReferenceLevel(numberingList, obj[json_list_enums_1.JSONNumberingOverrideListLevelProperty.Level]);
            }
            listLevel.setNewStart(obj[json_list_enums_1.JSONNumberingOverrideListLevelProperty.NewStart]);
            listLevel.overrideStart = !!obj[json_list_enums_1.JSONNumberingOverrideListLevelProperty.OverrideStart];
            result.push(listLevel);
        }
        return result;
    };
    return JSONNumberingListImporter;
}());
exports.JSONNumberingListImporter = JSONNumberingListImporter;
